import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueMask from "v-mask";
import VueTheMask from "vue-the-mask";
import money from "v-money";
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import VueGtag from "vue-gtag";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@/static/styles/_index.scss";

Vue.config.productionTip = false;

Vue.use(VueTheMask);
Vue.use(money, { precision: 2 });
Vue.use(VueMask);
Vue.use(Highcharts);
Vue.use(HighchartsVue);

Vue.use(VueGtag, {
  config: { id: "G-2M9DM2QD1C" }
}, router);

new Vue({
  router,
  created(){
    const token = localStorage.getItem("token-cp");
    if (!token) {
      router.push({ name: "Login", params: { name: "login" } });
    }
  },
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
